import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { ResonanceMark } from '../components/ui/ResonanceMark';
import { PublicAppearanceSelector } from '../components/ui/PublicAppearanceSelector';
import styles from './Marketing.module.css';

export function MarketingPage({ children }: { children: ReactNode }) {
  return (
    <div className={styles.page}>
      <div className="appGradient" />
      <header className={styles.nav}>
        <Link to="/" className={styles.brand}>
          <ResonanceMark size={22} className={styles.mark} />
          Resonance
        </Link>
        <nav className={styles.navLinks}>
          <PublicAppearanceSelector />
          <Link to="/pricing">Pricing</Link>
          <Link to="/about">About</Link>
          <Link to="/sign-in" className={styles.signIn}>
            Sign in
          </Link>
        </nav>
      </header>
      <main className={styles.main}>{children}</main>
      <footer className={styles.footer}>
        © {new Date().getFullYear()} Resonance
      </footer>
    </div>
  );
}
